import { OptionTitle } from "./OptionTitle"

export const NumberOfChildren: Array<OptionTitle> = [
  { id: "ONE_CHILD", title: "I have one child" },
  { id: "MULTIPLE_CHILDREN", title: "I have multiple children" }
]
